import React from 'react';
import classNames from 'classnames';

import css from './style.module.scss';

import Icon from '@sv-support-sdk/ui-components/src/components/Media/Icon';

import Button from '../../components/Controls/Button';

interface IProps {
  icon: string;
  title: string;
  description: string;
  isMobile?: boolean;
  action?: {
    text: string;
    onClick: () => void;
    disabled?: boolean;
  };
}

const ContentPlaceholder = ({ icon, title, description, isMobile, action }: IProps) => {
  return (
    <div className={classNames(css.contentPlaceholder, {
      [css.isMobile]: isMobile,
    })}>
      <div className={css.contentPlaceholder__image}>
        <Icon id={icon} />
      </div>
      <div className={css.contentPlaceholder__title}>{title}</div>
      <div className={css.contentPlaceholder__description}>{description}</div>
      {action && (
        <Button
          padding="0-26"
          isDisabled={action.disabled}
          width="auto"
          text={action.text}
          onClick={action.onClick}
        />
      )}
    </div>
  );
};

export default ContentPlaceholder;
